var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarleftarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.48352 7.71905C0.310329 7.54586 0.241053 7.33803 0.241053 7.09557C0.241053 6.88774 0.310329 6.67991 0.48352 6.50672L6.57984 0.687508C6.92622 0.375764 7.44579 0.375764 7.75753 0.722146C8.06928 1.03389 8.06928 1.5881 7.72289 1.89984L3.11602 6.26425H14.9276C15.3779 6.26425 15.7589 6.64527 15.7589 7.09557C15.7589 7.5805 15.3779 7.92688 14.9276 7.92688H3.11602L7.72289 12.3259C8.06928 12.6377 8.06928 13.1572 7.75753 13.5036C7.44579 13.85 6.92622 13.85 6.57984 13.5383L0.48352 7.71905Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarleftarrow);
export default __webpack_public_path__ + "static/media/calendarleftarrow.dc2e0a44198765015d9c5d34670e700e.svg";
export { ForwardRef as ReactComponent };